import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

// Domestic Japanese companies list (inspired by reference site)
const DOMESTIC_PARTNERS = [
  "BASE株式会社",
  "PayPal Holdings Inc.",
  "PayPay銀行株式会社",
  "Shopify Inc.",
  "アマゾン ジャパン合同会社/Amazon Japan G.K.",
  "グーグル合同会社/Google Japan G.K.",
  "ヤフー株式会社",
  "ヤマト運輸株式会社",
  "楽天グループ株式会社",
  "株式会社CAMPFIRE",
  "株式会社マクアケ",
  "株式会社メルカリ",
  "株式会社ワンモア",
  "佐川急便株式会社",
  "日本郵政株式会社",
  "北大阪商工会議所",
];

export default function PartnersSection() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("opacity-100", "translate-y-0");
            entry.target.classList.remove("opacity-0", "translate-y-8");
          }
        });
      },
      { threshold: 0.1 }
    );
    const children = sectionRef.current?.querySelectorAll(".animate-on-scroll");
    children?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="partners" className="py-24 md:py-36 bg-[#1a2332]" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 flex flex-col lg:flex-row gap-10 lg:gap-20 mb-16 md:mb-20">
          <div className="flex-1">
            <p className="text-xs text-white/40 tracking-[0.4em] uppercase mb-4">
              {t("partners.label")} / {t("partners.labelJa")}
            </p>

          </div>


        </div>

        {/* Partner List - Text based like reference site */}
        <div className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 delay-200">
          <h3 className="text-center text-white/80 text-lg font-medium mb-8">取引先企業一覧</h3>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3">
            {DOMESTIC_PARTNERS.map((partner, i) => (
              <li
                key={i}
                className="text-white/70 text-sm py-2 border-b border-white/10 hover:text-white transition-colors cursor-default flex items-center gap-3"
              >
                <span className="w-1 h-1 rounded-full bg-white/30 flex-shrink-0"></span>
                {partner}
              </li>
            ))}
          </ul>
        </div>

        <p className="animate-on-scroll opacity-0 translate-y-8 transition-all duration-700 delay-400 text-center text-xs text-white/30 mt-10">
          {t("partners.note")}
        </p>
      </div>
    </section>
  );
}